<h2 mat-dialog-tilte>
  <span class="shine">SERVICE COMMERCIAL </span>
  <img
    src="../../../../assets/icons/close.svg"
    alt="close"
    class="close-img"
    (click)="closeKeyDialog()"
    style="margin-right: 10px"
  />
</h2>
<mat-dialog-content>
  <div class="dialog-container">
    <div
      class="serviceComercialInfo_"
      fxFlex.xs="100%"
      fxFlex.sm="100"
      fxFlex.md="100"
      fxFlex.lg="100%"
      fxFlex.xl="100%"
    >
      <ul>
        <li>
          <img alt="" src="../../../../assets/icons/call-24px.svg" class="" />
          <span>
            <a href="tel:{{ contactInformation?.wissalPhoneNumber }}">{{
              contactInformation?.wissalPhoneNumber
            }}</a>
            /
            <a href="tel:{{ contactInformation?.wissalPhoneNumber2 }}">
              {{ contactInformation?.wissalPhoneNumber2 }}
            </a>
          </span>
        </li>
        <li>
          <img alt="" src="../../../../assets/icons/email-24px.svg" class="" />
          <span
            ><a href="mailto:info-wiunivers@wissalgroup.com"
              >info-wiunivers&#64;wissalgroup.com</a
            ></span
          >
        </li>
        <li>
          <img alt=""
            src="../../../../assets/icons/headset.svg"
            class=""
            style="align-self: baseline"
          />
          <span style="line-height: 1.7">
            08:30 - 21:00
            <span
              [ngClass]="
                getCommercialState() === 'OUVERT'
                  ? 'span-open-style'
                  : 'span-close-style'
              "
            >
              {{ 'globalUi.commercialService.' + getCommercialState() | translate }}
            </span>
          </span>
        </li>
        <li>
          <img alt=""
            src="../../../../assets/icons/store-2017%20(5).svg"
            class="class3434"
            style="align-self: baseline"
          />
          <span style="line-height: 1.7">
            08:30 - 17:00
            <span
              [ngClass]="
                getTimingStoreIsOpened() === 'OUVERT'
                  ? 'span-open-style'
                  : 'span-close-style'
              "
            >
              {{ 'globalUi.commercialService.' + getTimingStoreIsOpened() | translate }}
            </span>
          </span>
        </li>
        <li>
          <img alt=""
            src="../../../../assets/icons/location_on-24px.svg"
            class=""
            style="align-self: baseline"
          />
          <a
            rel="noopener"
            href="https://goo.gl/maps/Adhmz1j6ZoDojwMNA"
            target="_blank"
          >
            <span style="line-height: 1.7">{{
              contactInformation?.address
            }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="mapsLocation_container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1610.0583189847705!2d5.443087786508002!3d36.188045087929076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDExJzE3LjgiTiA1wrAyNiczNS4wIkU!5e0!3m2!1sfr!2sdz!4v1654510658910!5m2!1sfr!2sdz"
        width="400"
        height="500"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        aria-hidden="false"
        tabindex="0"
      >
      </iframe>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="btn-container">
    <button
      mat-stroked-button
      class="btn-mail"
      fxFlex.xl="49"
      fxFlex.lg="49"
      fxFlex.md="49"
      fxFlex.sm="49"
      (click)="sentMail()"
    >
      ENVOYEZ UN E-MAIL
    </button>
    <button
      mat-stroked-button
      class="btn-call"
      fxFlex.xl="49"
      fxFlex.lg="49"
      fxFlex.md="49"
      fxFlex.sm="49"
      (click)="callWissal()"
    >
      APPELEZ-NOUS
    </button>
  </div>
</mat-dialog-actions>
